import './StickyBottomCta.scss';

import { Container } from 'react-bootstrap';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons';

import IconButton from '@components/Button/IconButton';

import { useFvtWelcomeCta } from '../useFvtWelcomeCta';

interface StickyBottomCtaProps {
  visible: boolean;
}

export const StickyBottomCta = ({ visible }: StickyBottomCtaProps) => {
  const { onInviteCta } = useFvtWelcomeCta();

  return (
    <div
      className={`fvt-sticky-cta mt-4 mb-4${visible ? ' fvt-sticky-cta--visible' : ''}`}
      role={visible ? 'region' : undefined}
      aria-label={visible ? 'Invite relatives' : undefined}
      aria-hidden={!visible}
    >
      <Container fluid='xxl'>
        <div className='fvt-sticky-cta__inner py-3 px-4'>
          <div className='fvt-sticky-cta__text'>
            <div className='fvt-sticky-cta__title'>Ready when you are.</div>
            <div className='fvt-sticky-cta__sub mt-1'>
              This takes about 5 minutes. Once you submit, each relative will receive their private invitation.
            </div>
          </div>
          <IconButton
            className='primaryButtonStyling fvt-sticky-cta__button'
            type='button'
            startIcon={faUserPlus}
            onClick={onInviteCta}
          >
            Invite my relatives
          </IconButton>
        </div>
      </Container>
    </div>
  );
};
